import { useEffect, useState } from 'react'
import { z, ZodError } from 'zod'

interface CreateGroupData {
    groupName: string
}

const createGroupSchema = z.object({
    groupName: z.string().min(1, { message: 'Название группы обязательно' }),
})

export const useCreateGroupValidation = () => {
    const [errors, setErrors] = useState<
        Partial<Record<keyof CreateGroupData, string>>
    >({})

    const validate = (data: CreateGroupData): boolean => {
        try {
            createGroupSchema.parse(data)
            setErrors({})
            return true
        } catch (e) {
            if (e instanceof ZodError) {
                const fieldErrors: Partial<
                    Record<keyof CreateGroupData, string>
                > = {}

                e.issues.forEach((issue) => {
                    const path = issue.path[0] as keyof CreateGroupData
                    fieldErrors[path] = issue.message
                })

                setErrors(fieldErrors)
            }
            return false
        }
    }

    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            const timeout = setTimeout(() => {
                setErrors({})
            }, 1000)

            return () => clearTimeout(timeout)
        }
    }, [errors])

    return {
        isValid: Object.keys(errors).length === 0,
        errors,
        validate,
    }
}
